<template>
  <main class="bond">
    <div class="container">
      <div class="jumbotron mb-5"><h3>Ajoutez un nouveau bonds</h3><hr/>
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label class="">Intitule</label>
            <input type="text" class="form-control" v-model="payload.title">
          </div>
          <div class="form-group">
            <label class="">Description</label>
            <textarea class="form-control" v-model="payload.content"></textarea>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label class="">Début</label>
              <input type="date" class="form-control"  v-model="payload.startedAt">
            </div>
            <div class="form-group col-sm-6">
              <label class="">Fin</label>
              <input type="date" class="form-control"  v-model="payload.endedAt">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label class="">Montant</label>
              <div class="input-group">
                <input type="number" class="form-control"  v-model="payload.amount">
                <div class="input-group-prepend">
                  <select class="custom-select mr-sm-2" id="inlineFormCustomSelect">
                    <option value="1">EUR</option>
                    <option value="1">USD</option>
                    <option value="2">GBP</option>
                    <option value="3">XOF</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-6">
              <label class="">Total</label>
              <input type="text" class="form-control" disabled="disabled" :value="payload.score*payload.amount">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-6">
              <label class="">Minimum</label>
              <input type="number" class="form-control" v-model="payload.mini">
            </div>
            <div class="form-group col-sm-6">
              <label class="">Pourcentage</label>
              <input type="text" class="form-control" v-model="payload.score">
            </div>
          </div>
          <div class="form-group">
            <label class="">Code</label>
            <input type="password" class="form-control"  v-model="payload.code" autocomplete>
          </div>
          <hr class="my-4">
          <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
          <div class="form-group">
            <button type="submit" :class="[{ 'disabled': loading }, 'btn btn-outline-warning btn-lg']">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="loading"></span>
              Valider
            </button>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  name: 'bond',
  data() {
    return {loading: false, payload: {type: 'bond', score: 12}}
  },
  methods: {
    onSubmit() { 
      this.loading = true;
      this.$store.dispatch('transact/insertTrans', this.payload).then(
        () => {
          this.payload = {type: 'bond', score: 12}; 
          this.loading = false
        }
      )
    }
  },
}
</script>

<style scoped lang="scss">

</style>
